import React from 'react';
// import { Link } from 'react-router-dom';
import logo from '../Assets/Img/Fibre-bond-logo-full-White.png';
import { LayoutDashboard, ShoppingCart, BarChart2, Banknote, 
        IndianRupeeIcon, Scale, BadgeDollarSign, ArrowRightLeft, TextSearch, AudioWaveform, 
        ChartNetwork, BadgeCheck, HardDriveUpload, ShoppingBag, Wallet, Shuffle, Landmark, ScanLine } from 'lucide-react'; // Icons
import { NavLink } from "react-router-dom";

const Sidebar = ({ toggleSidebar }) => {
  return (
    <>
       {/* Internal CSS to hide scrollbar */}
      <style>
        {`
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
          .scrollbar-hide {
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;     /* Firefox */
          }
        `}
      </style>
      {/* Close Button - Only on mobile */}
      <div className="sm:hidden flex justify-end p-2 bg-gray-800">
        <button onClick={toggleSidebar} className="text-white hover:text-gray-300">
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="h-full px-4 py-5 overflow-y-auto bg-gray-800 text-white scrollbar-hide " style={{paddingBottom:'50px'}}>
        {/* Logo */}
        <div className="flex items-center space-x-3 mb-4">
          <img src={logo} alt="Logo" style={{ marginTop: '-11px', height: '50px', width: '160px' }} />
        </div>

        {/* Navigation */}
     
        <ul className="space-y-2 font-semibold">
  <li>
    <NavLink
      to="/home"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <LayoutDashboard className="w-5 h-5 mr-3" />
      Dashboard
    </NavLink>
  </li>
  <li>
    <NavLink
      to="/purchase"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <ShoppingCart className="w-5 h-5 mr-3" />
      Purchase
    </NavLink>
  </li>
  <li>
    <NavLink
      to="/sales"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <BarChart2 className="w-5 h-5 mr-3" />
      Sales
    </NavLink>
  </li>
  <li>
    <NavLink
      to="/Receipt-Payment"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <Banknote  className="w-5 h-5 mr-3" />
      Receipt & Payment
    </NavLink>
  </li>
    <li>
    <NavLink
      to="/Cash-Flow"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <IndianRupeeIcon  className="w-5 h-5 mr-3" />
      Cash Flow
    </NavLink>
  </li>
   <li>
    <NavLink
      to="/Stock-Valuation"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <Scale  className="w-5 h-5 mr-3" />
      Stock Valuation
    </NavLink>
  </li>
  <li>
    <NavLink
      to="/Sales-Tracking"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <Scale  className="w-5 h-5 mr-3" />
      Sales Tracking
    </NavLink>
  </li>
   <li>
    <NavLink
      to="/Budget-Vs-Actua"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <BadgeDollarSign  className="w-5 h-5 mr-3" />
      Budget Vs Actual
    </NavLink>
  </li>
  <li>
    <NavLink
      to="/Payables-Receivables"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <ArrowRightLeft   className="w-5 h-5 mr-3" />
      Payables & Receivables
    </NavLink>
  </li>
  <li>
    <NavLink
      to="/lot-wise-details"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <Shuffle  className="w-5 h-5 mr-3" />
      Process Wise Rate
    </NavLink>
  </li>

        <li>
        <NavLink
          to="/GST-RECO"
          className={({ isActive }) =>
            isActive
              ? "flex items-center p-2 rounded bg-gray-700"
              : "flex items-center p-2 rounded hover:bg-gray-600"
          }
        >
          <TextSearch   className="w-5 h-5 mr-3" />
        GST RECO
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/GST-RECO-Quarter"
          className={({ isActive }) =>
            isActive
              ? "flex items-center p-2 rounded bg-gray-700"
              : "flex items-center p-2 rounded hover:bg-gray-600"
          }
        >
          <TextSearch   className="w-5 h-5 mr-3" />
        GST RECO QUARTER
        </NavLink>
      </li>

      {/* New link added on 19 Jun 25 */}
        <li>
    <NavLink
      to="/Purchase-Capital-Expenditure"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <ChartNetwork   className="w-5 h-5 mr-3" />
     Purchase-Capital-Expenditure
    </NavLink>
  </li>
    <li>
    <NavLink
      to="/TDS-Report"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <AudioWaveform   className="w-5 h-5 mr-3" />
     TDS Report
    </NavLink>
  </li>
  <li>
    <NavLink
      to="/wages-calculation"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <Wallet className="w-5 h-5 mr-3" />
      Wages Calculation
    </NavLink>
  </li>
  <li>
    <NavLink
      to="/bank-tally-reco"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <Wallet className="w-5 h-5 mr-3" />
      HDFC CREDIT CARD
    </NavLink>
  </li>
  <li>
    <NavLink
      to="/icici-bank-tally-reco"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <Wallet className="w-5 h-5 mr-3" />
      ICICI CREDIT CARD
    </NavLink>
  </li>  <li>
    <NavLink
      to="/Account-Verification"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <BadgeCheck  className="w-5 h-5 mr-3" />
      Account Verification
    </NavLink>
  </li>

    <li>
    <NavLink
      to="/Tally-Import-Data"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <HardDriveUpload  className="w-5 h-5 mr-3" />
     Tally Import Data
    </NavLink>
  </li>
   <li>
    <NavLink
      to="/Purchase-Tracking"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <ShoppingBag  className="w-5 h-5 mr-3" />
     Purchase Tracking
    </NavLink>
  </li>

  <li>
    <NavLink
      to="/axis-automation"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <Landmark  className="w-5 h-5 mr-3" />
     Axis Automation
    </NavLink>
  </li>

  <li>
    <NavLink
      to="/Payable-Pending"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <ArrowRightLeft className="w-5 h-5 mr-3" />
      Payable Pending
    </NavLink>
  </li>

  {/* New link start here */}
  <li>
    <NavLink
      to="/purchase-dashboard"
      className={({ isActive }) =>
        isActive
          ? "flex items-center p-2 rounded bg-gray-700"
          : "flex items-center p-2 rounded hover:bg-gray-600"
      }
    >
      <ScanLine className="w-5 h-5 mr-3" />
      OCR Purchase Bills
    </NavLink>
  </li>
    </ul>
      </div>
    </>
  );
};

export default Sidebar;
